// source: proto/messages/user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var proto_messages_common_pb = require('../../proto/messages/common_pb.js');
goog.object.extend(proto, proto_messages_common_pb);
goog.exportSymbol('proto.proto.messages.Feedback', null, global);
goog.exportSymbol('proto.proto.messages.IDPUserInfo', null, global);
goog.exportSymbol('proto.proto.messages.User', null, global);
goog.exportSymbol('proto.proto.messages.UserProfile', null, global);
goog.exportSymbol('proto.proto.messages.UserProjects', null, global);
goog.exportSymbol('proto.proto.messages.UserRole', null, global);
goog.exportSymbol('proto.proto.messages.UserStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.UserProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.messages.UserProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.UserProfile.displayName = 'proto.proto.messages.UserProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.UserProjects = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.messages.UserProjects, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.UserProjects.displayName = 'proto.proto.messages.UserProjects';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.messages.User.repeatedFields_, null);
};
goog.inherits(proto.proto.messages.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.User.displayName = 'proto.proto.messages.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.IDPUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.messages.IDPUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.IDPUserInfo.displayName = 'proto.proto.messages.IDPUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.Feedback = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.messages.Feedback, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.Feedback.displayName = 'proto.proto.messages.Feedback';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.UserProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.UserProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.UserProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.UserProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    invitedby: (f = msg.getInvitedby()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    company: (f = msg.getCompany()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    jobtitle: (f = msg.getJobtitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.UserProfile}
 */
proto.proto.messages.UserProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.UserProfile;
  return proto.proto.messages.UserProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.UserProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.UserProfile}
 */
proto.proto.messages.UserProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInvitedby(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setJobtitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.UserProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.UserProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.UserProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.UserProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvitedby();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getJobtitle();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue invitedBy = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.proto.messages.UserProfile.prototype.getInvitedby = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.proto.messages.UserProfile} returns this
*/
proto.proto.messages.UserProfile.prototype.setInvitedby = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.UserProfile} returns this
 */
proto.proto.messages.UserProfile.prototype.clearInvitedby = function() {
  return this.setInvitedby(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.UserProfile.prototype.hasInvitedby = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue company = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.proto.messages.UserProfile.prototype.getCompany = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.proto.messages.UserProfile} returns this
*/
proto.proto.messages.UserProfile.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.UserProfile} returns this
 */
proto.proto.messages.UserProfile.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.UserProfile.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue jobTitle = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.proto.messages.UserProfile.prototype.getJobtitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.proto.messages.UserProfile} returns this
*/
proto.proto.messages.UserProfile.prototype.setJobtitle = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.UserProfile} returns this
 */
proto.proto.messages.UserProfile.prototype.clearJobtitle = function() {
  return this.setJobtitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.UserProfile.prototype.hasJobtitle = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.UserProjects.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.UserProjects.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.UserProjects} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.UserProjects.toObject = function(includeInstance, msg) {
  var f, obj = {
    all: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.UserProjects}
 */
proto.proto.messages.UserProjects.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.UserProjects;
  return proto.proto.messages.UserProjects.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.UserProjects} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.UserProjects}
 */
proto.proto.messages.UserProjects.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.UserProjects.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.UserProjects.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.UserProjects} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.UserProjects.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAll();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 all = 1;
 * @return {number}
 */
proto.proto.messages.UserProjects.prototype.getAll = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.messages.UserProjects} returns this
 */
proto.proto.messages.UserProjects.prototype.setAll = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.messages.User.repeatedFields_ = [6,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.User.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avatar: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phone: (f = msg.getPhone()) && proto_messages_common_pb.Phone.toObject(includeInstance, f),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    profile: (f = msg.getProfile()) && proto.proto.messages.UserProfile.toObject(includeInstance, f),
    projects: (f = msg.getProjects()) && proto.proto.messages.UserProjects.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0),
    createat: (f = msg.getCreateat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateat: (f = msg.getUpdateat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    idpinfosList: jspb.Message.toObjectList(msg.getIdpinfosList(),
    proto.proto.messages.IDPUserInfo.toObject, includeInstance),
    email: jspb.Message.getFieldWithDefault(msg, 13, ""),
    organizations: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.User}
 */
proto.proto.messages.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.User;
  return proto.proto.messages.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.User}
 */
proto.proto.messages.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    case 5:
      var value = new proto_messages_common_pb.Phone;
      reader.readMessage(value,proto_messages_common_pb.Phone.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.proto.messages.UserRole>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    case 7:
      var value = new proto.proto.messages.UserProfile;
      reader.readMessage(value,proto.proto.messages.UserProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 8:
      var value = new proto.proto.messages.UserProjects;
      reader.readMessage(value,proto.proto.messages.UserProjects.deserializeBinaryFromReader);
      msg.setProjects(value);
      break;
    case 9:
      var value = /** @type {!proto.proto.messages.UserStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateat(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateat(value);
      break;
    case 12:
      var value = new proto.proto.messages.IDPUserInfo;
      reader.readMessage(value,proto.proto.messages.IDPUserInfo.deserializeBinaryFromReader);
      msg.addIdpinfos(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrganizations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f !== 0) {
    writer.writeSint64(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto_messages_common_pb.Phone.serializeBinaryToWriter
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.messages.UserProfile.serializeBinaryToWriter
    );
  }
  f = message.getProjects();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.proto.messages.UserProjects.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCreateat();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateat();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIdpinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.proto.messages.IDPUserInfo.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOrganizations();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.messages.User.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sint64 username = 2;
 * @return {number}
 */
proto.proto.messages.User.prototype.getUsername = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setUsername = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.proto.messages.User.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string avatar = 4;
 * @return {string}
 */
proto.proto.messages.User.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Phone phone = 5;
 * @return {?proto.proto.messages.Phone}
 */
proto.proto.messages.User.prototype.getPhone = function() {
  return /** @type{?proto.proto.messages.Phone} */ (
    jspb.Message.getWrapperField(this, proto_messages_common_pb.Phone, 5));
};


/**
 * @param {?proto.proto.messages.Phone|undefined} value
 * @return {!proto.proto.messages.User} returns this
*/
proto.proto.messages.User.prototype.setPhone = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.User.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated UserRole roles = 6;
 * @return {!Array<!proto.proto.messages.UserRole>}
 */
proto.proto.messages.User.prototype.getRolesList = function() {
  return /** @type {!Array<!proto.proto.messages.UserRole>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.proto.messages.UserRole>} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.proto.messages.UserRole} value
 * @param {number=} opt_index
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};


/**
 * optional UserProfile profile = 7;
 * @return {?proto.proto.messages.UserProfile}
 */
proto.proto.messages.User.prototype.getProfile = function() {
  return /** @type{?proto.proto.messages.UserProfile} */ (
    jspb.Message.getWrapperField(this, proto.proto.messages.UserProfile, 7));
};


/**
 * @param {?proto.proto.messages.UserProfile|undefined} value
 * @return {!proto.proto.messages.User} returns this
*/
proto.proto.messages.User.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.User.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional UserProjects projects = 8;
 * @return {?proto.proto.messages.UserProjects}
 */
proto.proto.messages.User.prototype.getProjects = function() {
  return /** @type{?proto.proto.messages.UserProjects} */ (
    jspb.Message.getWrapperField(this, proto.proto.messages.UserProjects, 8));
};


/**
 * @param {?proto.proto.messages.UserProjects|undefined} value
 * @return {!proto.proto.messages.User} returns this
*/
proto.proto.messages.User.prototype.setProjects = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearProjects = function() {
  return this.setProjects(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.User.prototype.hasProjects = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional UserStatus status = 9;
 * @return {!proto.proto.messages.UserStatus}
 */
proto.proto.messages.User.prototype.getStatus = function() {
  return /** @type {!proto.proto.messages.UserStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.proto.messages.UserStatus} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp createAt = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.messages.User.prototype.getCreateat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.messages.User} returns this
*/
proto.proto.messages.User.prototype.setCreateat = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearCreateat = function() {
  return this.setCreateat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.User.prototype.hasCreateat = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp updateAt = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.messages.User.prototype.getUpdateat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.messages.User} returns this
*/
proto.proto.messages.User.prototype.setUpdateat = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearUpdateat = function() {
  return this.setUpdateat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.User.prototype.hasUpdateat = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated IDPUserInfo idpInfos = 12;
 * @return {!Array<!proto.proto.messages.IDPUserInfo>}
 */
proto.proto.messages.User.prototype.getIdpinfosList = function() {
  return /** @type{!Array<!proto.proto.messages.IDPUserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.messages.IDPUserInfo, 12));
};


/**
 * @param {!Array<!proto.proto.messages.IDPUserInfo>} value
 * @return {!proto.proto.messages.User} returns this
*/
proto.proto.messages.User.prototype.setIdpinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.proto.messages.IDPUserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.messages.IDPUserInfo}
 */
proto.proto.messages.User.prototype.addIdpinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.proto.messages.IDPUserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.clearIdpinfosList = function() {
  return this.setIdpinfosList([]);
};


/**
 * optional string email = 13;
 * @return {string}
 */
proto.proto.messages.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional uint32 organizations = 14;
 * @return {number}
 */
proto.proto.messages.User.prototype.getOrganizations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.messages.User} returns this
 */
proto.proto.messages.User.prototype.setOrganizations = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.IDPUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.IDPUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.IDPUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.IDPUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    idp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    username: jspb.Message.getFieldWithDefault(msg, 3, ""),
    displayname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.IDPUserInfo}
 */
proto.proto.messages.IDPUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.IDPUserInfo;
  return proto.proto.messages.IDPUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.IDPUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.IDPUserInfo}
 */
proto.proto.messages.IDPUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.messages.IDP} */ (reader.readEnum());
      msg.setIdp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.IDPUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.IDPUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.IDPUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.IDPUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdp();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional IDP idp = 1;
 * @return {!proto.proto.messages.IDP}
 */
proto.proto.messages.IDPUserInfo.prototype.getIdp = function() {
  return /** @type {!proto.proto.messages.IDP} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.messages.IDP} value
 * @return {!proto.proto.messages.IDPUserInfo} returns this
 */
proto.proto.messages.IDPUserInfo.prototype.setIdp = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.proto.messages.IDPUserInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.IDPUserInfo} returns this
 */
proto.proto.messages.IDPUserInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string userName = 3;
 * @return {string}
 */
proto.proto.messages.IDPUserInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.IDPUserInfo} returns this
 */
proto.proto.messages.IDPUserInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string displayName = 4;
 * @return {string}
 */
proto.proto.messages.IDPUserInfo.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.IDPUserInfo} returns this
 */
proto.proto.messages.IDPUserInfo.prototype.setDisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string avatarUrl = 5;
 * @return {string}
 */
proto.proto.messages.IDPUserInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.IDPUserInfo} returns this
 */
proto.proto.messages.IDPUserInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.Feedback.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.Feedback.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.Feedback} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.Feedback.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subject: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createat: (f = msg.getCreateat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.Feedback}
 */
proto.proto.messages.Feedback.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.Feedback;
  return proto.proto.messages.Feedback.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.Feedback} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.Feedback}
 */
proto.proto.messages.Feedback.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubject(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.Feedback.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.Feedback.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.Feedback} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.Feedback.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubject();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreateat();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.messages.Feedback.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.Feedback} returns this
 */
proto.proto.messages.Feedback.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string userId = 2;
 * @return {string}
 */
proto.proto.messages.Feedback.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.Feedback} returns this
 */
proto.proto.messages.Feedback.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subject = 3;
 * @return {string}
 */
proto.proto.messages.Feedback.prototype.getSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.Feedback} returns this
 */
proto.proto.messages.Feedback.prototype.setSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.proto.messages.Feedback.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.Feedback} returns this
 */
proto.proto.messages.Feedback.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp createAt = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.messages.Feedback.prototype.getCreateat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.messages.Feedback} returns this
*/
proto.proto.messages.Feedback.prototype.setCreateat = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.Feedback} returns this
 */
proto.proto.messages.Feedback.prototype.clearCreateat = function() {
  return this.setCreateat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.Feedback.prototype.hasCreateat = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.proto.messages.UserStatus = {
  INACTIVATED: 0,
  ACTIVATED: 1,
  FROZEN: 2,
  UNREGISTERED: 3
};

/**
 * @enum {number}
 */
proto.proto.messages.UserRole = {
  TULIP: 0,
  AQUA: 1,
  MASTER: 2
};

goog.object.extend(exports, proto.proto.messages);
